export const gaming = {
  title: "AI Gaming Generator",
  description: "Játékok létrehozása rajongóknak",
  
  typeSelection: {
    title: "Válassz játék típust",
    description: "Az AI segít elkészíteni a játékot a témád alapján, de bármikor kézzel is módosíthatod.",
    types: {
      quiz: {
        name: "Quiz (Kvíz)",
        description: "Interaktív kvíz kérdésekkel és válaszokkal"
      },
      wordScramble: {
        name: "Word Scramble (Betűkeverő)",
        description: "Szavak kitalálása kevert betűkből"
      },
      memory: {
        name: "Memory Game (Képpárosító)",
        description: "Párosítsd a képeket memóriajátékban"
      },
      giveaway: {
        name: "Giveaway / Challenge",
        description: "Sorsolás vagy kihívás a követőknek"
      },
      swipePoll: {
        name: "Swipe Poll (Szavazás)",
        description: "Gyors szavazás húzással"
      }
    },
    chooseButton: "Választom"
  },
  
  aiSetup: {
    title: "AI beállítások",
    theme: "Téma / Kulcsszavak",
    themePlaceholder: "pl. Edzéstervek otthonra",
    language: "Nyelv",
    questionCount: "Kérdések száma",
    wordCount: "Szavak száma",
    imageCount: "Képek száma",
    difficulty: "Nehézségi szint",
    difficultyLevels: {
      easy: "Könnyű",
      medium: "Közepes",
      hard: "Nehéz"
    },
    optionsCount: "Szavazási lehetőségek száma",
    generateButton: "AI generálja a játékot",
    generating: "Generálás folyamatban..."
  },
  
  manualEdit: {
    title: "Kézi szerkesztés",
    addQuestion: "Új kérdés hozzáadása",
    addWord: "Új szó hozzáadása",
    addImage: "Új kép hozzáadása",
    addOption: "Új lehetőség hozzáadása",
    editQuestion: "Kérdés szerkesztése",
    deleteQuestion: "Kérdés törlése",
    points: "Pontszám",
    timeLimit: "Időlimit (másodperc)",
    coverImage: "Borítókép",
    backgroundColor: "Háttérszín",
    buttonColor: "Gomb színe"
  },
  
  access: {
    title: "Hozzáférés és jutalom",
    whoCanPlay: "Kik játszhatnak?",
    levels: {
      public: "Minden látogató",
      subscribers: "Csak előfizetők",
      vip: "Csak VIP előfizetők",
      productOwners: "Csak akik megvették ezt a terméket"
    },
    selectProduct: "Válassz terméket",
    reward: "Mit kap, aki teljesíti / nyer?",
    rewardTypes: {
      coupon: "Kupon egy termékre",
      contentAccess: "Exkluzív hozzáférés tartalomhoz",
      subscriptionUpgrade: "Automatikus upgrade magasabb előfizetésre",
      leaderboardOnly: "Csak pontgyűjtés / Leaderboard megjelenés"
    },
    discountPercent: "Kedvezmény (%)",
    selectRewardProduct: "Válassz jutalomterméket",
    selectContent: "Válassz tartalmat",
    subscriptionTier: "Előfizetési szint",
    trialDays: "Próbaidőszak (napok)"
  },
  
  timing: {
    title: "Időzítés",
    startDate: "Kezdés dátuma",
    endDate: "Befejezés dátuma",
    autoPublish: "Eredmény automatikus publikálása"
  },
  
  visibility: {
    title: "Láthatóság",
    showOnLanding: "Nyilvános (landing-on is látszik)",
    showOnDashboard: "Csak előfizetői dashboardon",
    linkOnly: "Csak linkről elérhető"
  },
  
  preview: {
    title: "Előnézet",
    description: "Így fog kinézni a játék a rajongóid oldalán",
    generatedBanner: "Automatikusan generált banner"
  },
  
  actions: {
    saveDraft: "Mentés vázlatként",
    publishNow: "Publikálás most",
    schedulePublish: "Ütemezett publikálás",
    cancel: "Mégse",
    back: "Vissza",
    next: "Következő"
  },
  
  stats: {
    title: "Eredmények és statisztikák",
    participants: "Résztvevők",
    averageScore: "Átlagos pontszám",
    topPlayers: "Legjobb játékosok",
    conversionRate: "Konverziós arány",
    productPurchases: "Termék vásárlások",
    subscriptionUpgrades: "Előfizetés upgrade-ek"
  },
  
  toast: {
    gameGenerated: "Játék sikeresen generálva!",
    gameSaved: "Játék mentve!",
    gamePublished: "Játék publikálva!",
    error: "Hiba történt",
    fillRequired: "Töltsd ki a kötelező mezőket!"
  }
};
